import { removeRedundantObjects } from 'utils/group';
import { listTemplates, loadTemplate } from '../thunks/templates';

export const templatesReducer = (builder) => {
  builder
    .addCase(listTemplates.fulfilled, (state, action) => {
      const templates = action.payload || [];
      state.templates.value = removeRedundantObjects({ array: templates, property: 'id' });
      state.templates.loading = false;
    })
    .addCase(listTemplates.pending, (state) => {
      state.templates.loading = true;
    })
    .addCase(listTemplates.rejected, (state) => {
      state.templates.loading = false;
    });

  builder
    .addCase(loadTemplate.fulfilled, (state) => {
      state.loadingDocument = false;
    })
    .addCase(loadTemplate.pending, (state) => {
      state.loadingDocument = true;
    })
    .addCase(loadTemplate.rejected, (state) => {
      state.loadingDocument = false;
    });
};
